<div class="organization-modal modal-content" piqetAngularDraggable>
  <ng-container>
    <div class="modal-header header-modal">
      <span class="bootstrap-dialog-title header-title"
        >Add product manufacturing process to make 1kg/litre of product</span
      >
      <button type="button" aria-label="Close" class="closeModal pull-right" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>

    <div class="modal-body body-modal">
      <form [formGroup]="scenarioAddEditForm">
        <!-- Ingredient Start -->
        <div>
          <div class="sub-title">
            <h5>Ingredients</h5>
          </div>

          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 input-div">
              <div class="form-group required">
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #share
                  [items]="packageItems"
                  bindLabel="name"
                  [searchable]="false"
                  formControlName="share"
                  [searchFn]="commonInputSearch"
                  placeholder="Ingredients"
                >
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div">
              <div class="form-group required" aria-required="true">
                <div class="services-form">
                  <input
                    formControlName="projectName"
                    type="text"
                    maxlength="100"
                    placeholder="Weight"
                  />
                  <label>Weight</label>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div">
              <div class="form-group required" aria-required="true">
                <div class="services-form">
                  <input
                    formControlName="projectName"
                    type="text"
                    maxlength="100"
                    placeholder="Unit"
                  />
                  <label>Unit</label>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div">
              <div class="form-group required">
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #share
                  [items]="packageItems"
                  bindLabel="name"
                  [searchable]="false"
                  formControlName="share"
                  [searchFn]="commonInputSearch"
                  placeholder="Country"
                >
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 input-div">
              <div class="form-group required">
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #share
                  [items]="packageItems"
                  bindLabel="name"
                  [searchable]="false"
                  formControlName="share"
                  [searchFn]="commonInputSearch"
                  placeholder="Supplier"
                >
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-1 col-xl-1 input-div">
              <div class="d-flex justify-content-end">
                <button class="btn add-plus-button">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Need to add grid -->
        </div>
        <!-- Ingredient End -->

        <hr class="my-4" />

        <!-- Transport Start -->
        <div>
          <div class="sub-title">
            <h5>Transportation of ingredients to the manufacturer</h5>
          </div>

          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 input-div">
              <div class="form-group required">
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #share
                  [items]="packageItems"
                  bindLabel="name"
                  [searchable]="false"
                  formControlName="share"
                  [searchFn]="commonInputSearch"
                  placeholder="Ingredient"
                >
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>

          <!-- Transportation Selection -->
          <div class="my-3">
            <ul class="nav nav-pills nav-justified buttonTab" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="location-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#location"
                  type="button"
                  role="tab"
                  aria-controls="location"
                  aria-selected="true"
                >
                  <div class="image">
                    <img [src]="locationBlack" alt="" />
                  </div>
                  <div class="title">
                    <span>Based on location</span>
                  </div>
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="distance-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#distance"
                  type="button"
                  role="tab"
                  aria-controls="distance"
                  aria-selected="false"
                >
                  <div class="image">
                    <img [src]="distanceBlack" alt="" />
                  </div>
                  <div class="title">
                    <span>Based on distance</span>
                  </div>
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="custom-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#custom"
                  type="button"
                  role="tab"
                  aria-controls="custom"
                  aria-selected="false"
                >
                  <div class="image">
                    <img [src]="customBlack" alt="" />
                  </div>
                  <div class="title">
                    <span>Custom freight scenarios</span>
                  </div>
                </button>
              </li>
            </ul>
          </div>

          <!-- Transport button Content -->
          <div class="tab-content mt-3" id="myTabContent">
            <!-- Location -->
            <div
              class="tab-pane fade show active"
              id="location"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div class="row my-3">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div class="d-flex checkBoxAlienMent">
                    <div>
                      <input type="checkbox" class="chkOverview" />
                    </div>
                    <div>
                      <span style="color: black; margin-left: 15px">Custom truck</span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div
                    class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                  >
                    <div>
                      <!-- <button class="btn plus-button">
                                            <i class="fa fa-plus"></i>
                                        </button> -->
                    </div>
                    <div>
                      <span style="color: black">Add custom truck</span>
                      <i
                        class="fa fa-external-link"
                        style="color: black; padding-left: 10px"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-refresh"
                        style="color: black; padding-left: 10px"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 input-div">
                  <div class="form-group required">
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #share
                      [items]="packageItems"
                      bindLabel="name"
                      [searchable]="false"
                      formControlName="share"
                      [searchFn]="commonInputSearch"
                      placeholder="Select origin"
                    >
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div">
                  <div class="add-button">
                    <button class="btn purple-button">Set origin</button>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div">
                  <div
                    class="d-flex justify-content-end justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end"
                  >
                    <p class="btn gray-font p-0">Select location with "(Port)" for shipping</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Distancce -->
            <div
              class="tab-pane fade show"
              id="distance"
              role="tabpanel"
              aria-labelledby="distance-tab"
            >
              <div class="row my-3">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div class="d-flex checkBoxAlienMent">
                    <div>
                      <input type="checkbox" class="chkOverview" />
                    </div>
                    <div>
                      <span style="color: black; margin-left: 15px">Custom truck</span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div
                    class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                  >
                    <div>
                      <!-- <button class="btn plus-button">
                                            <i class="fa fa-plus"></i>
                                        </button> -->
                    </div>
                    <div>
                      <span style="color: black">Add custom truck</span>
                      <i
                        class="fa fa-external-link"
                        style="color: black; padding-left: 10px"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-refresh"
                        style="color: black; padding-left: 10px"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div">
                  <div class="form-group required">
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #share
                      [items]="packageItems"
                      bindLabel="name"
                      [searchable]="false"
                      formControlName="share"
                      [searchFn]="commonInputSearch"
                      placeholder="Select Transport mode"
                    >
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div">
                  <div class="form-group required" aria-required="true">
                    <div class="services-form">
                      <input
                        formControlName="projectName"
                        type="text"
                        maxlength="100"
                        placeholder="Component name"
                      />
                      <label>Distance</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div">
                  <div class="add-button">
                    <button class="btn purple-button">Add transport</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Custom -->
            <div
              class="tab-pane fade show"
              id="custom"
              role="tabpanel"
              aria-labelledby="custom-tab"
            >
              <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 input-div">
                  <div class="form-group required">
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #share
                      [items]="packageItems"
                      bindLabel="name"
                      [searchable]="false"
                      formControlName="share"
                      [searchFn]="commonInputSearch"
                      placeholder="Select custom freight mode"
                    >
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div">
                  <div class="add-button">
                    <button class="btn purple-button">Add freight</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Transport End -->

        <hr class="my-4" />

        <!-- Manufacturing process Start -->
        <div>
          <div class="sub-title">
            <h5>Manufacturing process</h5>
          </div>

          <div class="row my-3">
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <div class="d-flex checkBoxAlienMent">
                <div>
                  <input type="checkbox" class="chkOverview" />
                </div>
                <div>
                  <span style="color: black; margin-left: 15px">Custom manufacturing</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <div
                class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end"
              >
                <div>
                  <!-- <button class="btn plus-button">
                                    <i class="fa fa-plus"></i>
                                </button> -->
                </div>
                <div>
                  <span style="color: black">Add manufacturing process</span>
                  <i
                    class="fa fa-external-link"
                    style="color: black; padding-left: 10px"
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa fa-refresh"
                    style="color: black; padding-left: 10px"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div">
              <div class="form-group required">
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #share
                  [items]="packageItems"
                  bindLabel="name"
                  [searchable]="false"
                  formControlName="share"
                  [searchFn]="commonInputSearch"
                  placeholder="Process"
                >
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <!-- Hide for check box of custom manufacure is checked -->
            <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 input-div">
              <div class="form-group required" aria-required="true">
                <div class="services-form">
                  <input
                    formControlName="projectName"
                    type="text"
                    maxlength="100"
                    placeholder="Amount"
                  />
                  <label>Amount</label>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 input-div">
              <div class="add-button d-flex justify-content-end">
                <button class="btn purple-button">Add</button>
              </div>
            </div>
          </div>

          <!-- Need to add grid -->
        </div>
        <!-- Manufacturing process End -->
      </form>
    </div>

    <div class="modal-footer d-flex justify-content-start">
      <button
        type="button"
        class="actionBTN btn btn-light cancel-btn modelBtn purpleBtnHoverEffect"
        (click)="onClose()"
      >
        CANCEL
      </button>
      <button type="button" class="actionBTN modelBtn" (click)="onClose()">SAVE</button>
    </div>
  </ng-container>
</div>
